import Hero from './Hero';
import WhatWeDoSummary from './WhatWeDoSummary';
import ExperiencesPreview from './ExperiencesPreview';
import HowWeWork from './HowWeWork';
import PartnersDelivery from './PartnersDelivery';

const Home = () => {
  return (
    <div>
      <Hero />
      <HowWeWork />
      <WhatWeDoSummary />
      <ExperiencesPreview />
      <PartnersDelivery />
    </div>
  );
};

export default Home;